import React from 'react';
import {colors} from "../styles/colors";
import {translate} from 'react-i18next';
import ArrowBack from 'material-ui-icons/ArrowBack';
import {navigationBack} from "../navigation/NavigationActions";
import {connect} from "react-redux";
import {
    FacebookShareButton,
    WhatsappShareButton,
    EmailShareButton, FacebookIcon, WhatsappIcon, EmailIcon,
} from 'react-share';
import {saveHideShare, getHideShare} from "../utils/settingsStore";
import {ListItem} from "material-ui";
import {InfoOutline} from "material-ui-icons";
import {getUserSync} from "../utils/auth";


class FriendsScreen extends React.PureComponent {


    constructor(props) {
        super(props);
        this.state = {
            checkedA: getHideShare(),
        };
    }


    handleChange = name => event => {
        this.setState({[name]: event.target.checked}, () => {
            saveHideShare(this.state.checkedA);
        });
    };

    componentDidMount() {
        let hideShare = getHideShare();
        this.setState({["checkedA"]: hideShare});
    }

    getShareUrl(){
        return 'https://toplife.zone/live/' + getUserSync()._id
    }

    render() {
        const {t} = this.props;

        return (
            <div >
                <div className="toolbar">
                    <div className="back-arrow" onClick={() => this.props.goBack()}>
                        <ArrowBack />
                    </div>

                    <h2 style={styles.flex}>{t('friends:title')}</h2>

                </div>
                <div style={styles.shareContainer}>
                    <h1 style={styles.flex}>{t('friends:descriptionTitle')}</h1>
                    <p>{t('friends:description')}</p>

                    <div style={styles.share}>
                        <ListItem button style={styles.smListButton}>
                            <FacebookShareButton url={this.getShareUrl()} style={styles.smLayout}>
                                <FacebookIcon size={38} round={true}/>
                                <p style={styles.smText}>{t('friends:shareFacebook')}</p>
                            </FacebookShareButton>
                        </ListItem>

                        <ListItem button style={styles.smListButton}>
                            <WhatsappShareButton url={this.getShareUrl()} style={styles.smLayout}>
                                <WhatsappIcon size={38} round={true}/>
                                <p style={styles.smText}>{t('friends:shareWhatsApp')}</p>
                            </WhatsappShareButton>
                        </ListItem>

                        <ListItem button style={styles.smListButton}>
                            <EmailShareButton url={this.getShareUrl()} style={styles.smLayout}>
                                <EmailIcon size={38} round={true}/>
                                <p style={styles.smText}>{t('friends:shareEmail')}</p>
                            </EmailShareButton>
                        </ListItem>

                    </div>
                        <div style={styles.highlight}>
                            <InfoOutline color='inherit' size={2} style={styles.icon}/>
                            <p>{t('friends:descriptionInfo')}</p>
                        </div>

                        <p style={styles.smSkip} onClick={() => this.props.goBack()}>{t('friends:skipShare')}</p>


                    {/*<div  style={styles.hideShareLayout}>
                     <FormControlLabel
                     control={
                     <Checkbox
                     checked={this.state.checkedA}
                     onChange={this.handleChange('checkedA')}
                     color="default"
                     value="checkedA"
                     />
                     }
                     label={t('friends:hideShare')}
                     />
                     </div>*/}
                </div>
            </div>
        );
    }

}


const styles = ({
    shareContainer: {
        maxWidth: 512,
        margin: '0 auto',
        paddingTop: 72,
        paddingRight: 16,
        paddingLeft: 16
    },
    flex: {
        flex: 1,
    },
    share: {
        marginTop: 16,
        marginBottom: 16,
    },
    highlight:{
        flex: 1,
        display: 'flex',
        padding: 16,
        backgroundColor: colors.white,
        boxShadow: `0 1px 3px 0 rgba(41,70,97,.2)`,
        borderRadius: 3,
    },
    icon:{
        marginRight: 16,
    },
    smLayout: {
        flex: 1,
        display: 'flex',
        alignItems: 'center',
        outline: 'none'
    },
    smText: {
        paddingLeft: 16
    },
    smListButton: {
        paddingLeft: 16
    },
    smSkip: {
        paddingTop: 16,
        paddingBottom: 16,
        textDecoration: 'underline',
        cursor: 'pointer',
        textAlign: 'center',
        color: colors.text_light
    },
    hideShareLayout: {
        paddingTop: 32,
    }
});

/*
 const mapStateToProps = (state) => {
 return {
 user: state.auth.user,
 loadingLevelFailed: state.loadingLevelFailed,
 isLoading: state.levelLoading
 };
 };*/

const mapDispatchToProps = (dispatch) => {
    return {
        goBack: () => dispatch(navigationBack())
    };
};

export default connect(null, mapDispatchToProps)(translate(['friends', 'common'])(FriendsScreen));


// WEBPACK FOOTER //
// ./src/friends/FriendsScreen.js